import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PRICING_PROFILE_MASSIVE_UPDATE_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import PricingProfileMassiveUpdateForm from './PricingProfileMassiveUpdateForm';
import { postPricingProfileDateSchedule } from '../../../../actions';
import { tzNormalizeDate } from '../../../../utils/date';
import { INT_DATE_FORMAT } from '../../../../config/locale';

const NewPricingProfileMassiveUpdate = ({
  breadcrumbs,
  dispatchPostPricingProfileDateSchedule,
}) => {
  const onSubmit = (formValues) => {
    const newFormValues = {
      ...formValues,
      startDate: tzNormalizeDate({
        date: formValues.startDate,
        format: INT_DATE_FORMAT,
      }),
      endDate: tzNormalizeDate({
        date: formValues.endDate,
        format: INT_DATE_FORMAT,
      }),
    };

    dispatchPostPricingProfileDateSchedule(newFormValues);
  };

  const content = <PricingProfileMassiveUpdateForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Registrar Actualizacion Masiva de Perfiles de Precio"
      subtitle="Registrar actualizacion masiva de perfiles de precio"
      content={content}
    />
  );
};

NewPricingProfileMassiveUpdate.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostPricingProfileDateSchedule: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostPricingProfileDateSchedule: postPricingProfileDateSchedule,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Actualizaciones Masivas de Perfiles de Precio',
      href: PRICING_PROFILE_MASSIVE_UPDATE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewPricingProfileMassiveUpdate);
